import React, { useRef, useEffect } from 'react';
import { Form } from 'react-bootstrap';

export default function AutoExpandingTextarea({
    value,
    onChange,
    name,
    placeholder,
    disabled,
    isInvalid,
    minRows = 2,
    maxRows,
    allowResize = false,
    ...props
}) {
    const textareaRef = useRef(null);

    useEffect(() => {
        if (textareaRef.current) {
            // Reset height to auto to get the correct scrollHeight
            textareaRef.current.style.height = 'auto';

            if (maxRows) {
                // Calculate the max height based on maxRows
                const lineHeight = parseFloat(getComputedStyle(textareaRef.current).lineHeight);
                const maxHeight = maxRows * lineHeight;

                // Set new height based on scrollHeight, but cap at maxHeight
                const newHeight = Math.min(textareaRef.current.scrollHeight, maxHeight);
                textareaRef.current.style.height = `${newHeight}px`;

                // Show scrollbar if content exceeds maxHeight
                textareaRef.current.style.overflowY = textareaRef.current.scrollHeight > maxHeight ? 'auto' : 'hidden';
            } else {
                // No max limit - expand freely
                textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
                textareaRef.current.style.overflowY = 'hidden';
            }
        }
    }, [value, maxRows]);

    return (
        <Form.Control
            ref={textareaRef}
            as="textarea"
            rows={minRows}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            isInvalid={isInvalid}
            style={{
                minHeight: `${minRows * 1.5}em`, // Adjust based on your line height
                resize: allowResize ? 'vertical' : 'none',
                overflow: allowResize ? 'auto' : 'hidden',
                height: 'auto',
                ...(maxRows && { maxHeight: `${maxRows * 1.5}em` }), // Optional CSS max-height as fallback
            }}
            {...props}
        />
    );
}
